export default __webpack_public_path__ + "static/tag-dont-5-light-434a04df654a31ff6217010fc4e5973eace69c3ccc982a6660109eab48447778.png";